function slick(){
  $('.images-slider').slick({
    infinite: false,
    autoplay: true,
    speed: 1000,
    dots: false,
    arrows: false,
    variableWidth: true,
  });
}

export default {
  init() {
    slick();
  }
};
